import { render, staticRenderFns } from "./myClient.vue?vue&type=template&id=1d5957b8&scoped=true&"
import script from "./myClient.vue?vue&type=script&lang=js&"
export * from "./myClient.vue?vue&type=script&lang=js&"
import style0 from "./myClient.vue?vue&type=style&index=0&id=1d5957b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5957b8",
  null
  
)

export default component.exports